/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import mbpLogger from '@module-logger/mbp';
// import axios from 'axios';
import restClient from '../../../app/helpers/restClient';
import { getGuestUserAccessToken } from '../../../state/ducks/Member/ducks/Auth/Plugin/auth/guest';

export const bumbleBeeSignal = async (token, reqBody = {}) => {
    try {
        const freshToken = await getGuestUserAccessToken() || token;
        const route = 'bumblebee/signal';

        const response = await restClient.postFacade({ rootUri: '/' }, route, freshToken, reqBody);
        delete response.headers;
        delete response.request;
        delete response.config;
        // * Local testing region:
        // const response = await axios.post('http://localhost:8085/bb_api/signal', reqBody);
    } catch (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            errorMessage: error,
            message: `WebChat: Send Bumblebee Signal: ${error} - convid: ${reqBody?.conversationId}`,
        });
    }
};

export default bumbleBeeSignal;
